import log from 'loglevel';
import { ISiteSectionEntry } from '@move-frontend/contentful';
import {
	IAH_SITE_SECTION_ID,
	HOU_SITE_SECTION_ID,
	EFD_SITE_SECTION_ID,
	SPACEPORT_SITE_SECTION_ID,
	CORPORATE_SITE_SECTION_ID,
} from '../contentful';

// Site section order is fixed. Any unknown section will be add at the end.
const orderedSiteSectionIds = [
	IAH_SITE_SECTION_ID,
	HOU_SITE_SECTION_ID,
	EFD_SITE_SECTION_ID,
	SPACEPORT_SITE_SECTION_ID,
	CORPORATE_SITE_SECTION_ID,
];

export function getOrderedSiteSections(siteSections: ISiteSectionEntry[]) {
	return [
		...siteSections.filter((section) => !section.fields.hideFromTopNavigation),
	].sort((a, b) => {
		const indexA = getIndexForSectionId(a.fields.id);
		const indexB = getIndexForSectionId(b.fields.id);

		return indexA - indexB;
	});
}

function getIndexForSectionId(id: string) {
	const index = orderedSiteSectionIds.indexOf(id);

	// Make sure unknown sections will be added last
	if (index === -1) {
		log.warn('Unknown site section ID', id);
		return Infinity;
	}

	return index;
}
